import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CallHistoryService {

  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/callHistory";

  ur2 = environment.serverAPI4 + "/api/manageReport";


  CallHistory(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  CallHistoryExcel(query: string, page: number, size: number, sort: string, groupBy: any, columnsConfig: any): Observable<any> {
    return this.CallHistory(query, page, size, sort, groupBy).pipe(
      map((res: any) => {
        let content = res['content'];
        if (content && columnsConfig && Array.isArray(columnsConfig)) {
          res['content'] = content.map((item: any) => {
            let newItem: any = {};
            for (let col of columnsConfig) {
              let value = item[col.property];
              if (col.property === 'typeAndTime') {
                value = this.formatSecondsToTime(value);
              }
              newItem[col.name] = value;
            }
            return newItem;
          });
        }
        return res;
      })
    );
  }

  private formatSecondsToTime(secondsInput: any): string {
    const seconds = parseInt(secondsInput, 10);
    if (isNaN(seconds) || seconds < 0) {
      return '00:00:00';
    }
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  ManageReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur2}/condition${queryParams}`, requestBody);
  }
}
